import React, { useEffect, useState } from 'react';
import { Container, Grid, Typography, Box, Stack, Pagination, PaginationItem, useTheme } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import axios from 'axios';
import Shoot from '../../../../layout/Shoot';
import Sidebar from '../Sidebar';

function ShopCard({onLoaded}) {
  const theme = useTheme();
  const [AllProduct, setAllProduct] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalProductCount, setTotalProductCount] = useState(0);
  const itemsPerPage = 12; // Number of items per page

  const fetchFilteredProducts = async (filters) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_APP}/api/GetAllProduct?page=${currentPage}&limit=${itemsPerPage}`);
      setAllProduct(response.data.data);
      setTotalPages(response.data.totalPages);
      setTotalProductCount(response.data.totalRecords)
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      onLoaded();
    }
  };

  useEffect(() => {
    fetchFilteredProducts({});
  }, []);

  useEffect(() => {
    fetchFilteredProducts();
  }, [currentPage])

  return (
    <Box sx={{ backgroundColor: theme.palette.background.default, color: '#000', padding: { lg: '50px 100px', xs: '50px 0px' } }}>
      <Container maxWidth="xxl">
        <Grid container spacing={3}>
          {/* <Grid item xs={12} md={3.5} xl={3}>
            <Sidebar onFilterChange={handleFilterChange} collectionclick={handlecollectionClick}/>
          </Grid> */}
          <Grid item xs={12}>
            <Box sx={{ p: { sm: 3, xs: 1 } }}>
              <Box sx={{ mb: 4, borderBottom: '1px solid #343333', pb: 3, mt: 5 }}>
                <Typography variant="h6" sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px' }}>
                  Showing 1 – {itemsPerPage} of {totalProductCount} results
                </Typography>
              </Box>
              <Grid container>
                {AllProduct.map((val, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Shoot
                      primaryImg={val?.ProductImage}
                      // primaryImg={`${process.env.REACT_APP_BACKEND_APP}/uploads/` + val?.ProductImage}
                      title={val?.ClothesType}
                      price={val.ProductPrice}
                      ShirtMeter={val?.ShirtMeter}
                      PaintMeter={val?.PaintMeter}
                      DiscountPrice={val?.DiscountPrice}
                      FabricType={val?.FabricType} 
                      TrouserMeter={val?.TrouserMeter} 
                      KurtaMeter={val?.KurtaMeter}
                      slug={val.unqid}
                      imageHeight={"500px"}
                    />
                  </Grid>
                ))}
              </Grid>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
                <Stack spacing={4}>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={(event, value) => setCurrentPage(value)}
                    renderItem={(item) => (
                      <PaginationItem
                        slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                        sx={{ fontFamily: theme.palette.typography.fontFamily1, fontSize: '20px' }}
                      />
                    )}
                  />
                </Stack>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default ShopCard;
